module.exports = __webpack_public_path__ + "static/media/result2.43f89409.png";


//////////////////
// WEBPACK FOOTER
// ./src/safetyTrainingExam/images/result2.png
// module id = 1414
// module chunks = 0